// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__WD8vp","upload":"Small_upload__vF8CE","imageWrap":"Small_imageWrap__2-HNc","removeBtn":"Small_removeBtn__2hXiv"};